import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countWorkOrderStatusPipe'
})
export class CountWorkOrderStatusPipePipe implements PipeTransform {

  transform(workOrders: any[], status: string): number {
    return workOrders.filter(order => order.status === status).length;
  }

}
